import { ArgsService } from 'src/services/args.service';
import { isRenderer } from './isRenderer';

export const getArgsValue = async (varName: string): Promise<string | null> => {
  if (isRenderer()) {
    return window.electron.requestAppArgument(varName);
  }

  return ArgsService.getArg(varName);
};
